/* import __COLOCATED_TEMPLATE__ from './data-table-cell.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

interface TeammateMapping {
  id: number;
  name: string;
}

interface KnowledgeHubContentReference {
  id: number;
  title: string;
  localized_entity_name: string;
  entity_type: number;
  deleted: boolean;
}

type Args = {
  dataType: string;
  value: any;
};

export default class DataTableCell extends Component<Args> {
  @service declare appService: AppService;

  @action
  formatAdminNames(cellValue: TeammateMapping | TeammateMapping[]) {
    let valueArray = [cellValue].flat();
    return valueArray.map((admin) => admin.name).join(', ');
  }

  @action
  formatKnowledgeHubContentReferences(
    cellValue: KnowledgeHubContentReference | KnowledgeHubContentReference[],
  ) {
    let valueArray = [cellValue].flat();
    return valueArray
      .map((item: KnowledgeHubContentReference) => `${item.title} (${item.localized_entity_name})`)
      .join(', ');
  }

  @action
  getAdminById(id: any) {
    return this.appService.app.admins.findBy('id', id.toString());
  }

  @action
  textForStamp(value: any) {
    let remaining = value.length - 2;
    return `+ ${remaining} more`;
  }

  @action
  firstTwoAdmins(cellValue: TeammateMapping | TeammateMapping[]) {
    let valueArray = [cellValue].flat();
    return (
      valueArray
        .slice(0, 2)
        // Avoid displaying admins when they have empty names
        .filter((admin) => admin.name)
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::DataTableCell': typeof DataTableCell;
  }
}
